import {POST} from "@/services/gateway";

const listSnapshotDetails = ({userIds, folderId, snapshotDateTime, pagination, searchTerm}) => {
  return POST('dropbox/drive/search', {userIds, folderId, snapshotDateTime, pagination, searchTerm})
}

const listBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('dropbox/drive/breadcrumbs', {userId, folderId, snapshotDate})
}


export {
  listSnapshotDetails,
  listBreadcrumps
}
